<template>
    <container-page :headerHeight="'24%'" :bodyHeight="'88%'">
        <template v-slot:header>
            <div class="bodyPage" v-if="user.ADM != 'S'">
                <no-adm-banner/>
            </div>
            <div class="headerPage" v-if="user.ADM == 'S'">
                <span class="titlePage"> {{'Ajustes' | translate('Ajustes')}} </span>
            </div>
            <div v-if="user.ADM == 'S'">
                <div id="borderBottomTabs" class="borderBottomTabs"></div>
                <v-tabs
                    v-resize="onResize"
                    height="50px"
                    class="headerTabs"
                    color="black"
                    slider-size="4" 
                    v-model="tab"
                    show-arrows
                >
                    <v-tab class="ajustesTab" @click="changeRouter('/empresa');">
                        <span>{{labels.empresa}}</span>
                    </v-tab>
                    <v-tab class="ajustesTab" @click="changeRouter('/acessos_permissoes');">
                        <span>{{labels.acessos}}</span>
                    </v-tab>
                </v-tabs>
            </div>
        </template>
        <template v-slot:body v-if="user.ADM == 'S'">
            <div>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <router-view />
                    </v-tab-item>
                    <v-tab-item>
                        <router-view />
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </container-page>
</template>

<script>
import translate from '../../../src/plugins/translate'
import ContainerPage from '../../../src/components/containerPage.vue'
import NoAdmBanner from '../../../src/components/NoAdmBanner'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')

export default {
    name: 'Ajustes',
    components: {ContainerPage, NoAdmBanner},
    data() {
        return {
            tab: null,
            labels: {
                empresa: translate('Empresa', 'Ajustes'),
                acessos: translate('Acessos e permissões', 'Ajustes'),
                preferencias: translate('Preferências', 'Ajustes')
            }
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    methods: {
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.buildborderTabs()
        },
        changeRouter(route) {
            this.$router.push(route)
        },
        buildborderTabs() {
            var allTabs = document.getElementsByClassName('ajustesTab')
            var widthBorderBoddom = 0
            allTabs.forEach(function(tab){
                widthBorderBoddom += tab.offsetWidth
            })
            let element = document.getElementById('borderBottomTabs')
            this.$nextTick(function(){
                element.style.width = `${widthBorderBoddom}px`
            })
        }
    },
    mounted(){
        this.onResize()
    }

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.ajustesTab > span{
    font-weight: bolder !important;
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    top: 50px;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
}
</style>
